<template>
  <PSMessagePush />
</template>

<script>
export default {
    data() {
        return {
        }
    }
}
</script>
